module.exports = __webpack_public_path__ + "static/media/linkedIn.ab7bd994.svg";